import { IInventoryFilter, IProduct, IProductCatalogsData, IProductCompany, IProductInventoryDetails, IProductOrdersKPI } from "../models/products.models";
import { Action, createReducer, on } from "@ngrx/store";
import * as productsActions from './produits.actions';
import { IPagination } from 'src/app/shared/models/page.model';
import { refillInventoryFilter } from "src/app/shared/utils/helpers";

export interface ProductsFilterState {
  advanced: IInventoryFilter;
  keyword: string;
}

export interface ProductsSortByState {
  key: string;
  mode: string;
}

export interface ProductsState {
  products: IProduct[];
  allProducts: IProduct[];
  metadata: IPagination | null;
  loading: boolean;
  variantLoading: boolean;
  searchLoading: boolean;
  productFilterState: ProductsFilterState;
  productsBySearch: IProduct[];
  productCompanies: IProductCompany | null;
  productCatalogs: IProductCatalogsData | null;
  productOrdersKPI: IProductOrdersKPI | null;
  productsSortBy: ProductsSortByState;
  productInventoryDetails: IProductInventoryDetails | null;
  searchMetadata: IPagination | null;
}

export const initialProductsState: ProductsState = {
  products: [],
  metadata: null,
  allProducts: [],
  loading: false,
  variantLoading: false,
  searchLoading: false,
  productFilterState: {
    advanced: refillInventoryFilter(),
    keyword: ''
  },
  productsBySearch: [],
  productCompanies: null,
  productCatalogs: null,
  productOrdersKPI: null,
  productInventoryDetails: null,
  productsSortBy: {
    key: '',
    mode: ''
  },
  searchMetadata: null
};

const featureReducer = createReducer(
  initialProductsState,
  on(
    productsActions.FetchAllProductsSuccess,
    (state, action) => ({
      ...state,
      allProducts: action.products.data,
    })
  ),
  on(
    productsActions.FetchProductsSuccess,
    (state, action) => ({
      ...state,
      products: action.products.data,
      metadata: action.products.metadata
    })
  ),
  on(
    productsActions.FetchProductsBySearchSuccess,
    (state, action) => ({
      ...state,
      productsBySearch: action.append
        ? [...state.productsBySearch, ...action.products.data]
        : action.products.data,
      metadata: action.products.metadata,
      searchMetadata: action.products.metadata
    })
  ),
  on(productsActions.SetProductLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(productsActions.SetVariantsLoader, (state, action) => ({
    ...state,
    variantLoading: action.isLoading
  })),
  on(productsActions.SetInventoryFilter, (state, action) => ({
    ...state,
    productFilterState: {
      advanced: action.advanced!,
      keyword : action.keyword
    }
  })),
  on(productsActions.SetInventorySearch, (state, action) => ({
    ...state,
    productFilterState: {
      ...state.productFilterState,
      keyword: action.keyword,
    }
  })),
  on(productsActions.SetSearchProductLoader, (state, action) => ({
    ...state,
    searchLoading: action.isLoading
  })),
  on(productsActions.exportProducts, (state) => ({
    ...state,
    loading: true,
  })),
  on(productsActions.exportProductsSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(productsActions.ClearProducts, (state) => ({
    ...state,
    productsBySearch: [],
    products: [],
    metadata: null,
    searchMetadata: null
  })),
  on(
    productsActions.GetProductCompaniesSuccess,
    (state, action) => ({
      ...state,
      productCompanies: action.productCompanies.object!,
    })
  ),
  on(
    productsActions.GetProductCatalogsSuccess,
    (state, action) => ({
      ...state,
      productCatalogs: action.productCatalogs.object!,
    })
  ),
  on(
    productsActions.GetProductOrdersKPISuccess,
    (state, action) => ({
      ...state,
      productOrdersKPI: action.productOrdersKPI.object!,
    })
  ),
  on(
    productsActions.ClearKpisProduct,
    (state) => ({
      ...state,
      productOrdersKPI: null,
    })
  ),
  on(
    productsActions.GetProductInventoryDetailsSuccess,
    (state, action) => ({
      ...state,
      productInventoryDetails: action.inventoryDetails.object!,
    })
  ),
  on(
    productsActions.ClearProductInventoryDetails,
    (state) => ({
      ...state,
      productInventoryDetails: null,
    })
  ),
  on(productsActions.SetInventorySortBy, (state, action) => ({
    ...state,
    productsSortBy: {
      key: action.key,
      mode : action.mode
    }
  })),
);

export function productsReducer(state: ProductsState | undefined, action: Action) {
  return featureReducer(state, action);
}
